import { Directive, input } from '@angular/core'
import { SidebarToggleDirective } from './sidebar-toggle.directive'

@Directive({
    selector: '[sfSidebarToggler]',
    hostDirectives: [{ directive: SidebarToggleDirective, inputs: ['sfSidebarToggle: sfSidebarToggler', 'toggle'] }],
    host: {
        '[attr.role]': 'role()',
        class: 'sidebar-toggler',
        '[style]': 'getStyles',
    },
})
export class SidebarTogglerDirective {
    readonly role = input('button')

    get getStyles(): any {
        return {
            appearance: 'button',
            'align-items': 'flex-start',
            cursor: 'pointer',
        }
    }
}
